import React from 'react';
import Button from '../button/Button';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import './InitialActionButtons.scss';
import { CLIENT_NAME } from '../../../src/js/config/_global';

type InitialActionButtonsProps = {
    onLoginClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

const InitialActionButtons = ({ onLoginClick }: InitialActionButtonsProps) => {
    const { t } = useTranslation();

    return (
        <div className={classnames('b-initial-action-buttons', {
            'is-bentley': CLIENT_NAME === 'bentley',
        })}>
            <Button
                name="login-button"
                secondaryButton={CLIENT_NAME !== 'bentley'}
                text={t('initial_login_action')}
                authButton={false}
                clickHandler={onLoginClick}
            />
        </div>
    );
};

export default InitialActionButtons;